module.exports = __webpack_public_path__ + "static/media/implant.c3ea1dea.png";